import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setPlateFeeValue } from '../../redux/modules/registration';
import Dropdown from '../../components/Dropdown';
import { VEHICLES } from '../../modules/constants';
import precise from '../../modules/precise';
import plateFeeTotal from '../../selectors/plateFeeTotal.selector';

class TotalPlateFee extends Component {
  constructor(props) {
    super(props);
    this.onValueSelect = this.onValueSelect.bind(this);
  }

  onValueSelect(event) {
    const value = event.target.value;
    const label = this.renderOptions()[event.target.selectedIndex][0];
    this.props.setPlateFeeValue(precise(value), value, label);
  }

  renderOptions() {
    const { selectedVehicleType, BFfee } = this.props;

    const defaultOptions = [
      ['No Plate Issue Fee', 0],
      ['License Plate Issue Fee', 28],
      ['Replacement Only (MV License Plate)', 36.9],
      ['Replacement Only (MV Decal)', 34.1],
      ['Replacement Vessel Decal', 4.25],
      ['Replacement HS Decal', 7.5],
      ['Temporary License Plate', 42],
      ['Front End License Plate (Add Plate Mail Fee)', 5],
    ];

    const vesselOptions = [
      ['No Plate fee required', 0],
      ['Replacement Vessel Decal', 3.75 + BFfee],
    ];

    const motorVehicleOptions = [
      ['No Plate Issue Fee', 0.00],
      ['License Plate Issue Fee', 28.00],
      // 5.00 front end plate ADD plate mail fee
      ['Front End License Plate (Add Plate Mail Fee)', 5.00],
    ];

    const mobileHomeOptions = [
      ['No Plate fee required', 0.00],
      ['Replacement HS Decal', 19.60 + BFfee],
    ];

    if (
      selectedVehicleType === VEHICLES.MOTOR_VEHICLE ||
      selectedVehicleType === VEHICLES.HEAVY_TRUCKS ||
      selectedVehicleType === VEHICLES.LEASE_HIRE_TRAILER ||
      selectedVehicleType === VEHICLES.BUSES_TRAILER
    ) {
      return motorVehicleOptions;
    }

    if (selectedVehicleType === VEHICLES.VESSELS) {
      return vesselOptions;
    }

    if (selectedVehicleType === VEHICLES.MOBILE_HOMES) {
      return mobileHomeOptions;
    }

    return defaultOptions;
  }

  render() {
    const { plateFee, plateFeeSelectedValue, plateFeeSelectedValueLabel } = this.props;
    return (
      <div className="Row Registration-plateFeeRow">
        <input
          className="Row-total"
          id="totalPlateFee"
          data-id="Rsub4"
          data-tooltip="$100 Initial Registration Fee"
          type="text"
          value={plateFee}
          readOnly
          tabIndex="-1"
        />

        <Dropdown
          id="PlateFee"
          tooltip="Issue tag fees"
          options={this.renderOptions()}
          onChange={this.onValueSelect}
          selectedValue={plateFeeSelectedValue}
          className="Dropdown Row-dropdown no-print"
        />

        <b className="print-label print-only">{plateFeeSelectedValueLabel}</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedVehicleType: state.registration.selectedVehicleType,
    plateFee: plateFeeTotal(state),
    plateFeeSelectedValue: state.registration.plateFeeSelectedValue,
    plateFeeSelectedValueLabel: state.registration.plateFeeSelectedValueLabel,
    BFfee: state.registration.BFfee,
  };
};

export default connect(mapStateToProps, { setPlateFeeValue })(TotalPlateFee);



// WEBPACK FOOTER //
// ./src/containers/registration/TotalPlateFee.js